import React, { useState, useEffect, useRef }       from "react";
import ChatSessionService                           from 'services/chat-session.service';
import AuthService                                  from 'services/auth.service';
import IconHealthInfo                               from 'assets/icons/healthInfoIcon.svg';
import IconArrowDown                                from "assets/icons/expandAllIcon.svg";
import { Accordion, Card, Button }                  from "react-bootstrap";
import moment                                       from 'moment';
import Spinner                                      from 'react-bootstrap/Spinner';

function AccordianHealthMedication2({ chat }) {
  const isCancelled = useRef(false);
  const [infos, setInfos] = useState({});
  const [health_data, setHealthData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getNutritionInfo();
    getHealthDataSummary();
    return () => {
      isCancelled.current = true;
    };
  }, []); // eslint-disable-line

  const getNutritionInfo = () => {
    setLoading(true);
    ChatSessionService.getNutritionInfo(chat.id).then(
      (res) => { 
        setInfos(res);
        setLoading(false);
      },(error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  };

  const getBmi = (bmi) => {
    let bmi_value = bmi || 0;
    return bmi_value.toFixed(2);
  };

  const getHealthDataSummary = () => {
    setLoading(true);
    let params = {
      user_id: chat.user_info.id,
    };
    ChatSessionService.getHealthDataSummary(params).then(
      (res) => {
        setHealthData(res.health_data_summary);
        setLoading(false);
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  };

  return (
    <>
      <Card className="health-med-info card-accordian">
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey="1">
            <div className="header-title">
              <img
                src={IconHealthInfo}
                alt="icon-info-circle"
                className="title-icon"
              />
              <div className="title">Health Information</div>
            </div>
            <div>
              <img src={IconArrowDown} alt="icon-arrow-down" />
            </div>
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="1">
          <Card.Body>
            {loading ? <div className="loader"><Spinner animation="border" className="spinner"/></div> : (
              <>
                <div className="info-row">
                  <div className="label">Height</div>
                  <div className="info">{infos.height || '0'} cm</div>
                </div>
                <div className="info-row">
                  <div className="label">Weight</div>
                  <div className="info">{infos.weight || '0'} kg</div>
                </div>
                <div className="info-row">
                  <div className="label">BMI</div>
                  <div className="info">{getBmi(infos.bmi)} kg/m²</div>
                </div>
                <div className="info-row">
                  <div className="label">Last Updated On</div>
                  <div className="info">
                    {infos.updated_at
                      ? moment(infos.updated_at).format("DD/MM/YYYY")
                      : "-"}{" "}
                  </div>
                </div>

                <div className="info-row">
                  <div className="label">Blood Glucose (none-fasting) </div>
                  <div className="info">
                    {health_data.blood_glucose || 0} mmol/L
                  </div>
                </div>
                <div className="info-row">
                  <div className="label">Blood Glucose (fasting) </div>
                  <div className="info">
                    {health_data.blood_glucose_fasting || 0} mmol/L
                  </div>
                </div>
              </>
            )}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
}

export default AccordianHealthMedication2;
